import comp from "./Card";
export default comp;
